export const ORDER_EDIT_EXPIRATIONS = "ORDER_EDIT_EXPIRATIONS";
export const ORDER_EDIT_SERVICES    = "ORDER_EDIT_SERVICES";
export const ORDER_CLONE_SERVICES    = "ORDER_CLONE_SERVICES";
export const ORDER_EDIT_PRODUCTS    = "ORDER_EDIT_PRODUCTS";
